import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.maintenance-plans-report-table', () => {
  void import('./internal/maintenance-plans-report-table')
    .then(({ default: Component }) => Component());
});

onElelementExistRunOnce('#show_additional_block', () => {
  void import('./internal/show_additional_block').then(({ default: Component }) => Component());
});
